import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Table } from "primeng/table";
import { v4 as uuidv4 } from "uuid";
import { AddNotesRequestDto } from "../../../core/models/cdi/AddNotesRequestDto";
import { OcrInvoiceMatchingNotes } from "../../../core/models/cdi/CDINotes";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { SalesOrderNotes } from "../../../core/models/orders/salesOrderNotes";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { CDISummaryService } from "../../../core/services/cdi-resolution-summary.service";
import { LoaderService } from "../../../core/services/loader.service";
import { ProfileFormService } from "../../../core/services/profile-form.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { UserManagementService } from "../../../core/services/user-management.service";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@UntilDestroy()
@Component({
  selector: "jni-cdi-notes",
  templateUrl: "./cdi-notes.component.html",
  styleUrls: ["./cdi-notes.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class CdiNotesComponent implements OnInit {
  @Input() saleOrderId = "";
  @Input() poNumber = "";
  @Input() recId = "";
  @Input() cdiNotesGridListing: OcrInvoiceMatchingNotes[] = [];
  @Output() selectedOrderNotesListing = new EventEmitter<
    OcrInvoiceMatchingNotes[]
  >();
  @Output() refreshNotesGrid = new EventEmitter<number>();
  @Output() quickNoteChangeEvent = new EventEmitter<string>();

  @ViewChild("dt") table!: Table;
  selectedCdiNotesGridListing: OcrInvoiceMatchingNotes[] = [];
  quickQuote = "";
  public quickNotesMandatory = false;

  typeList = [
    {
      id: 1,
      name: "Billing note",
    },
    {
      id: 2,
      name: "Collections",
    },
    // 11286 - PGL-270 Remove Invoice Note option From All Note Forms
    // {
    //   id: 3,
    //   name: 'Invoice note'
    // },
    {
      id: 4,
      name: "Order note",
    },
  ];
  loggedInUserName = "";

  constructor(
    private _cdiSummaryService: CDISummaryService,
    private _loaderService: LoaderService,
    private _toastrService: JniToastrService,
    private _loginService: UserManagementService,
    private _profileFormService: ProfileFormService
  ) {}

  ngOnInit(): void {
    this.getUserProfile();
  }

  onQuickQuote() {
    this._loaderService.setLoaderState(true);

    const quickNote = {
      notes: this.loggedInUserName + " - " + this.quickQuote,
      recId: Number.parseInt(this.recId),
    } as AddNotesRequestDto;

    this._cdiSummaryService
      .addQuickNotes(quickNote)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          //this.getSalesOrderNotes(this.saleOrderId);
          if (res.data) {
            this._toastrService.success(
              "Success",
              "Order Note Added Successfully"
            );

            this.refreshNotesGrid.emit(Number.parseFloat(this.recId));
          } else {
            this._toastrService.error(
              "Error",
              res.message || "Error adding order note"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastrService.error(
            "Error",
            res.message || "Error adding order note"
          );
        },
      });
    const saleOrderFormObject = {
      description: "CDI Note - PO " + this.poNumber,
      id: 0,
      note: this.loggedInUserName + " - " + this.quickQuote,
      portalKey: "",
      purchaseOrderStatus: false,
      salesOrderId: "",
      type: "Billing note",
    } as SalesOrderNotes;

    if (this.saleOrderId) {
      saleOrderFormObject.salesOrderId = this.saleOrderId;
      saleOrderFormObject.portalKey = uuidv4();
    }

    this._cdiSummaryService
      .AddSalesOrderNotes(saleOrderFormObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          // this._loaderService.setLoaderState(false);
          //this.getSalesOrderNotes(this.saleOrderId);
          this.quickQuote = "";
          // this._toastrService.success(
          //   'Success',
          //   'Order Note Added Successfully'
          // );
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastrService.error(
            "Error",
            res.message || "Error adding order note"
          );
        },
      });
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res.data != null) {
          this.loggedInUserName = res.data.name;
        }
      },
    });
  }

  onQuickQuoteChange() {
    this.quickNoteChangeEvent.emit(this.quickQuote);
  }
}
